/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { generateClient } from "@aws-amplify/api";
import { Form, Field } from "react-final-form";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import NotificationComponent from "./Notification";
// GraphQL imports
import {
  Order,
  OrdersByInvoiceNumberQueryVariables,
  ModelOrderFilterInput,
  ModelStringInput,
} from "../src/API";
import { ordersByInvoiceNumberCustom } from "../src/graphql/custom_queries";

function TrackingComponent() {
  const [data, setData] = React.useState([{}]);
  const [loaded, setLoaded] = React.useState<boolean>(false);
  const client = generateClient();

  async function fetchOrderData(email: string, invoiceNumber: string) {
    const filteremail: ModelStringInput = { eq: email };
    const filter: ModelOrderFilterInput = {
      email: filteremail,
    };
    const variables: OrdersByInvoiceNumberQueryVariables = {
      invoiceNumber,
      filter,
    };
    const request = (await client.graphql({
      query: ordersByInvoiceNumberCustom,
      variables,
    })) as {
      data: { ordersByInvoiceNumber: { items: Order[] } };
      errors: unknown[];
    };
    setData(request.data.ordersByInvoiceNumber.items);
    setLoaded(true);
  }

  const onSubmit = async (values) => {
    await new Promise((resolve) => setTimeout(resolve, 500));
    try {
      await fetchOrderData(
        values.email as string,
        values.invoiceNumber as string,
      );
      // console.log(data);
    } catch (err) {
      console.log(err);
    }
  };

  const required = (value) => (value ? undefined : "Required");

  return (
    <>
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit, form }) => {
          const { submitting } = form.getState();
          return (
            <div className="w-60 flex justify-center items-center">
              <form onSubmit={handleSubmit}>
                <Field name="email" validate={required}>
                  {({ input, meta }) => (
                    <div>
                      <label>Email</label>
                      <input
                        {...input}
                        type="email"
                        placeholder="Email Address"
                        className="amplify-input"
                      />
                      {meta.error && meta.touched && (
                        <span className="text-red-500 hover:text-red-700">
                          {meta.error}
                        </span>
                      )}
                    </div>
                  )}
                </Field>
                <Field name="invoiceNumber" validate={required}>
                  {({ input, meta }) => (
                    <div className="pt-2">
                      <label>Your Invoice Number:</label>
                      <input
                        {...input}
                        type="text"
                        placeholder="12E1234F-0001"
                        className="amplify-input"
                      />
                      {meta.error && meta.touched && (
                        <span className="text-red-500 hover:text-red-700">
                          {meta.error}
                        </span>
                      )}
                    </div>
                  )}
                </Field>
                <div className="mt-2 flex items-center justify-center">
                  <button
                    type="submit"
                    className="bg-black text-white py-2 px-4 mt-4 hover:bg-gray-800 focus:outline-none active:bg-gray-800"
                    disabled={submitting}
                  >
                    Track Order
                  </button>
                </div>
              </form>
            </div>
          );
        }}
      />

      {loaded && (
        <>
          {data?.length < 1 ? (
            <NotificationComponent content="No orders found" color="red" />
          ) : (
            <div className="py-12 px-4">
              <nav className="flex justify-center" aria-label="Progress">
                <ol className="space-y-16">
                  {data.map((step: any) => (
                    <li key={step.id}>
                      {step.fulfillment_status === null ||
                        (step.fulfillment_status === "Order Received" && (
                          <>
                            <div className="group">
                              <span className="flex items-start">
                                <span className="flex-shrink-0 relative h-8 w-8 flex items-center justify-center">
                                  <CheckCircleIcon
                                    className="h-full w-full text-green-600"
                                    aria-hidden="true"
                                  />
                                </span>
                                <span className="ml-3 mt-1 text-md font-medium text-black">
                                  Order Received
                                </span>
                              </span>
                            </div>

                            <div
                              className="flex items-start"
                              aria-current="step"
                            >
                              <span
                                className="flex-shrink-0 h-8 w-8 relative flex items-center justify-center"
                                aria-hidden="true"
                              >
                                <span className="absolute h-6 w-6 rounded-full bg-gray-200" />
                              </span>
                              <span className="ml-3 mt-1 text-md font-medium text-gray-600">
                                Processing
                              </span>
                            </div>

                            <div
                              className="flex items-start"
                              aria-current="step"
                            >
                              <span
                                className="flex-shrink-0 h-8 w-8 relative flex items-center justify-center"
                                aria-hidden="true"
                              >
                                <span className="absolute h-6 w-6 rounded-full bg-gray-200" />
                              </span>
                              <span className="ml-3 mt-1 text-md font-medium text-gray-600">
                                Shipped
                              </span>
                            </div>

                            <div
                              className="flex items-start"
                              aria-current="step"
                            >
                              <span
                                className="flex-shrink-0 h-8 w-8 relative flex items-center justify-center"
                                aria-hidden="true"
                              >
                                <span className="absolute h-6 w-6 rounded-full bg-gray-200" />
                              </span>
                              <span className="ml-3 mt-1 text-md font-medium text-gray-600">
                                Delivered
                              </span>
                            </div>
                          </>
                        ))}

                      {step.fulfillment_status === "Processing" && (
                        <>
                          <div className="group">
                            <span className="flex items-start">
                              <span className="flex-shrink-0 relative h-8 w-8 flex items-center justify-center">
                                <CheckCircleIcon
                                  className="h-full w-full text-green-600"
                                  aria-hidden="true"
                                />
                              </span>
                              <span className="ml-3 mt-1 text-md font-medium text-black">
                                Order Received
                              </span>
                            </span>
                          </div>

                          <div className="group">
                            <span className="flex items-start">
                              <span className="flex-shrink-0 relative h-8 w-8 flex items-center justify-center">
                                <CheckCircleIcon
                                  className="h-full w-full text-green-600 "
                                  aria-hidden="true"
                                />
                              </span>
                              <span className="ml-3 mt-1 text-md font-medium text-black">
                                Processing
                              </span>
                            </span>
                          </div>

                          <div className="flex items-start" aria-current="step">
                            <span
                              className="flex-shrink-0 h-8 w-8 relative flex items-center justify-center"
                              aria-hidden="true"
                            >
                              <span className="absolute h-6 w-6 rounded-full bg-gray-200" />
                            </span>
                            <span className="ml-3 mt-1 text-md font-medium text-gray-600">
                              Shipped
                            </span>
                          </div>

                          <div className="flex items-start" aria-current="step">
                            <span
                              className="flex-shrink-0 h-8 w-8 relative flex items-center justify-center"
                              aria-hidden="true"
                            >
                              <span className="absolute h-6 w-6 rounded-full bg-gray-200" />
                            </span>
                            <span className="ml-3 mt-1 text-md font-medium text-gray-600">
                              Delivered
                            </span>
                          </div>
                        </>
                      )}

                      {step.fulfillment_status === "Shipped" && (
                        <>
                          <div className="group">
                            <span className="flex items-start">
                              <span className="flex-shrink-0 relative h-8 w-8 flex items-center justify-center">
                                <CheckCircleIcon
                                  className="h-full w-full text-green-600 "
                                  aria-hidden="true"
                                />
                              </span>
                              <span className="ml-3 mt-1 text-md font-medium text-black">
                                Order Received
                              </span>
                            </span>
                          </div>

                          <div className="group">
                            <span className="flex items-start">
                              <span className="flex-shrink-0 relative h-8 w-8 flex items-center justify-center">
                                <CheckCircleIcon
                                  className="h-full w-full text-green-600 "
                                  aria-hidden="true"
                                />
                              </span>
                              <span className="ml-3 mt-1 text-md font-medium text-black">
                                Processing
                              </span>
                            </span>
                          </div>

                          <div className="group">
                            <span className="flex items-start">
                              <span className="flex-shrink-0 relative h-8 w-8 flex items-center justify-center">
                                <CheckCircleIcon
                                  className="h-full w-full text-green-600 "
                                  aria-hidden="true"
                                />
                              </span>
                              <span className="ml-3 mt-1 text-md font-medium text-black">
                                Shipped
                              </span>
                            </span>
                          </div>

                          <div>
                            Tracking Number: {step.fulfillment_tracking_id}
                          </div>

                          <div className="flex items-start" aria-current="step">
                            <span
                              className="flex-shrink-0 h-8 w-8 relative flex items-center justify-center"
                              aria-hidden="true"
                            >
                              <span className="absolute h-6 w-6 rounded-full bg-gray-200" />
                            </span>
                            <span className="ml-3 mt-1 text-md font-medium text-gray-600">
                              Delivered
                            </span>
                          </div>
                        </>
                      )}

                      {step.fulfillment_status === "Delivered" && (
                        <>
                          <div className="group">
                            <span className="flex items-start">
                              <span className="flex-shrink-0 relative h-8 w-8 flex items-center justify-center">
                                <CheckCircleIcon
                                  className="h-full w-full text-green-600 "
                                  aria-hidden="true"
                                />
                              </span>
                              <span className="ml-3 mt-1 text-md font-medium text-black">
                                Order Received
                              </span>
                            </span>
                          </div>

                          <div className="group">
                            <span className="flex items-start">
                              <span className="flex-shrink-0 relative h-8 w-8 flex items-center justify-center">
                                <CheckCircleIcon
                                  className="h-full w-full text-green-600 "
                                  aria-hidden="true"
                                />
                              </span>
                              <span className="ml-3 mt-1 text-md font-medium text-black">
                                Processing
                              </span>
                            </span>
                          </div>
                          <div className="group">
                            <span className="flex items-start">
                              <span className="flex-shrink-0 relative h-8 w-8 flex items-center justify-center">
                                <CheckCircleIcon
                                  className="h-full w-full text-green-600 "
                                  aria-hidden="true"
                                />
                              </span>
                              <span className="ml-3 mt-1 text-md font-medium text-black">
                                Shipped
                              </span>
                            </span>
                          </div>

                          <div className="group">
                            <span className="flex items-start">
                              <span className="flex-shrink-0 relative h-8 w-8 flex items-center justify-center">
                                <CheckCircleIcon
                                  className="h-full w-full text-green-600 "
                                  aria-hidden="true"
                                />
                              </span>
                              <span className="ml-3 mt-1 text-md font-medium text-black">
                                Delivered
                              </span>
                            </span>
                          </div>
                        </>
                      )}
                    </li>
                  ))}
                </ol>
              </nav>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default TrackingComponent;
